export const externalUrls = {
  exchangeMarketingPage:
    'https://www.boldpenguin.com/core-pages/request-a-demo',
  jiraCreateBugPage:
    'https://boldpenguin.atlassian.net/servicedesk/customer/portal/7',
};

export const baWorkflowUrls = {
  riskSelectionGuide:
    'https://brokeragealliances.amfam.com/brokeragealliances/pages/products/comm_lines-2.asp',
  acordLibrary:
    'https://brokeragealliances.amfam.com/brokeragealliances/pages/tools-AccordLibrary.asp',
  stateSpecificAcordLibrary:
    'https://brokeragealliances.amfam.com/brokeragealliances/pages/tools-AccordLibrary_StateSpecific.asp',
};
